export default __webpack_public_path__ + "static/media/730C.49fc1255.pdf";